import { render, staticRenderFns } from "./PIDSet.vue?vue&type=template&id=4ef6fcc8&scoped=true"
import script from "./PIDSet.vue?vue&type=script&lang=js"
export * from "./PIDSet.vue?vue&type=script&lang=js"
import style0 from "./PIDSet.vue?vue&type=style&index=0&id=4ef6fcc8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef6fcc8",
  null
  
)

export default component.exports